import React from "react"
import { useLabels } from "../../../../../../features/contents/hooks"
import MenuList from "../../../../../../ui/molecules/Menu/MenuList"
import { useAlgoliaSearchState } from "../../../controller/state"
import { AlgoliaCheckboxCategory } from "../../../controller/state/types"
import { getSelectedCategories } from "../../../filters/CurrentFilterTags/hooks"
import { FacetOption } from "../../../filters/types"
import { SelectedFilterCategory } from "../../types"

interface Props {
  onSelectedCategoryChange: (category: SelectedFilterCategory) => void
}

const getSelectedTags = (category: AlgoliaCheckboxCategory) =>
  category.options.filter((x) => x.selected).map((x) => x.label)

const getSelectedBrand = (brands: FacetOption[]) =>
  brands.filter((x) => x.selected).map((x) => x.label)

const FiltersModalCategoriesList = ({ onSelectedCategoryChange }: Props) => {
  const { uiFilters } = useAlgoliaSearchState()
  const { getLabel } = useLabels()
  return (
    <div>
      <MenuList
        items={[
          {
            content: getLabel("search", "category-filter"),
            subtitle: uiFilters?.categories
              ? getSelectedCategories(uiFilters.categories)
                  .map((x) => x.label)
                  .join(", ")
              : "",
            onItemClick: () =>
              onSelectedCategoryChange({
                type: "category",
              }),
          },
          {
            content: getLabel("search", "brand-filter"),
            subtitle: getSelectedBrand(uiFilters?.brands ?? []).join(", "),
            onItemClick: () =>
              onSelectedCategoryChange({
                type: "brand",
              }),
          },
          {
            content: getLabel("search", "price-filter"),
            subtitle: "",
            onItemClick: () =>
              onSelectedCategoryChange({
                type: "price",
              }),
          },
          ...(uiFilters?.tags
            ?.filter((x) => x.hasActiveOptions)
            ?.map((category) => ({
              content: category.label,
              subtitle: getSelectedTags(category).join(", "),
              onItemClick: () =>
                onSelectedCategoryChange({
                  type: "tag",
                  item: category,
                }),
            })) ?? []),
        ]}
        bordersBottom
        center
        px={1}
      />
    </div>
  )
}

export default FiltersModalCategoriesList
